<template>
  <div id="laureat" v-if="videos">
    <div class="top">
      <div class="upper">
        <div class="title">
          <span v-if="year">Vidéos {{year}}</span>
          <span v-else>Toutes les vidéos</span>
        </div>
      </div>
    </div>

    <div id="videos">
      <Single v-for="(item, index) in videos" :key="item.video" :item="item" :stop="stop" :index="index" @stopAll="stopAll" />
    </div>
  </div>
</template>

<script>
import Single from '@/components/SingleVideo.vue'

export default {
  data () {
    return {
      stop: false
    }
  },

  components: {
    Single
  },

  methods: {
    stopAll (index) {
      this.stop = index
    }
  },

  computed: {
    year () {
      let vy
      if (this.$route.params.vidyear) {
        vy = this.$route.params.vidyear
      } else {
        vy = null
      }

      return vy
    },

    videos () {
      if (this.year && this.$store.getters.videos) {
        return this.$store.getters.videos.filter(item => item.year.title.toString() === this.year)
      } else {
        return this.$store.getters.videos
      }
    }
  },

  mounted () {
    this.$store.commit('editState', { state: 'cardActive', data: false })
    this.$store.commit('editState', { state: 'cardOpen', data: false })
    this.$root.$emit('scrollAfterEnter')
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

#videos {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
  padding-bottom: calc(#{$menu} + 2rem);
}
</style>
